<span
  class="inline-flex items-center whitespace-nowrap rounded-full border border-solid px-2.5 py-0.5 text-xs font-medium leading-[18px]"
  [ngClass]="{
    'border-green-200 bg-green-100 text-green-800':
      state() === EngagementState.Active,
    'border-amber-200 bg-amber-100 text-amber-800':
      state() === EngagementState.Slowing,
    'border-red-200 bg-red-100 text-red-800':
      state() === EngagementState.Disengaged,
    'border-red-400 bg-transparent text-red-800':
      state() === EngagementState.NeverEngaged,
    'border-slate-200 bg-slate-100 text-slate-600':
      state() === EngagementState.NoData
  }"
>
  {{ label() }}
</span>
